<template>
    <div class="tab-pane fade" id="nav-RecentCoaching" role="tabpanel" aria-labelledby="nav-RecentCoaching-tab"
        tabindex="0">
        <div class="table-responsive">
            <a-table class="table datatable" :columns="columns" :data-source="data">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'Player_Name'">
                        <h2 class="table-avatar">
                            <router-link to="/coaches/my-profile" class="avatar avatar-sm  flex-shrink-0"><img class="avatar-img"
                                    :src="require(`@/assets/img/profiles/${record.Image}`)" alt="User"></router-link>
                            <span class="table-head-name table-name-user flex-grow-1">
                                <router-link to="/coaches/my-profile">{{record.Player_Name}}</router-link>
                            </span>
                        </h2>
                    </template>
                    <template v-else-if="column.key === 'Date'">
                        <div class="table-date-time">
                            <h4>{{record.Date}}<span>{{record.Time}}</span></h4>
                        </div>
                    </template>
                    <template v-else-if="column.key === 'Payment'">
                        <div><span class="pay-dark">{{record.Payment}}</span></div>
                    </template>
                    <template v-else-if="column.key === 'Status'">
                        <div class="paid-edit"><span><i class="feather-edit"></i>{{record.Status}}</span>                    
                        </div>
                    </template>
                    <template v-else-if="column.key === 'action'">
                        <td class="table-accept-btn text-end">
                            <a href="javascript:;" class="btn accept-btn"><i class="feather-check-circle"></i>Accept</a>
                            <a href="javascript:;" class="btn cancel-table-btn" data-bs-toggle="modal"
                                data-bs-target="#request-reject"><i class="feather-x-circle"></i>Cancel</a>
                        </td>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
const data = [
  {
    Image: "avatar-01.jpg",
    Player_Name: "Johnson",
    Lesson_Type: "Single Lesson",
    Date: "Fri, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$250",
    Status: "Paid",
  },
  {
    Image: "avatar-02.jpg",
    Player_Name: "Andy",
    Lesson_Type: "Onetime",
    Date: "Mon, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$150",
    Status: "Paid",
  },
  {
    Image: "avatar-06.jpg",
    Player_Name: "Pranika",
    Lesson_Type: "Group Lessons",
    Date: "Wed, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$150",
    Status: "Paid",
  },
  {
    Image: "avatar-03.jpg",
    Player_Name: "Ariyan",
    Lesson_Type: "Onetime",
    Date: "Wed, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$150",
    Status: "Paid",
  },
];

const columns = [
  {
    title: "Player Name",
    dataIndex: "Player_Name",
    key: "Player_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Player_Name.toLowerCase();
        b = b.Player_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Lesson Type",
    dataIndex: "Lesson_Type",
    sorter: {
      compare: (a, b) => {
        a = a.Lesson_Type.toLowerCase();
        b = b.Lesson_Type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
export default {
  data() {
    return {
      columns,
      data,
    };
  },
};
</script>
